import { Routes } from '@angular/router';

export const appRoutes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('@features/payment-gateway/payment-gateway.routes').then(
        (m) => m.paymentGateWayRoutes,
      ),
  },
];
